import script from "./FAQLibrary.vue?vue&type=script&setup=true&lang=ts"
export * from "./FAQLibrary.vue?vue&type=script&setup=true&lang=ts"

import "./FAQLibrary.vue?vue&type=style&index=0&id=153a7211&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153a7211"]])

export default __exports__